import { ITableFiltersObject } from "@monorepo/utils/src/store/types/tableFiltersObject";
import { formDateFilter } from "@monorepo/utils/src/api/convertFiltersToApi";

export const convertFiltersCustomToApi = (resultFilters: ITableFiltersObject & { fieldFilters: { date?: string } }): void => {
  formDateFilter(resultFilters, "date");
};
